export default "/directory/static/performs_interfaith.c652d40e.svg";